import React, { createContext, useState } from "react";

interface JsonContextData {
  jsonData: any | null;
  setJsonData: React.Dispatch<React.SetStateAction<any | null>>;
}

export const JsonContext = createContext<JsonContextData>({
  jsonData: "",
  setJsonData: () => { },
});

export const JsonProvider = (props: { children: React.ReactNode }) => {
  const [jsonData, setJsonData] = useState<string>("");

  return (
    <JsonContext.Provider value={{ jsonData, setJsonData }}>
      {props.children}
    </JsonContext.Provider>
  );
}; 
